<template>
    <StaticSpinner v-if="!isEventsLoaded" />
    <div v-else-if="events.length > 0" class="section">
        <div class="headingContainer">
            <Heading
                v-gtm:type="'Upcoming'"
                v-gtm:@view
            >
                {{ i18n.t('tournament_center_title_upcoming_matches') }}
            </Heading>
            <VButton
                v-gtm:label="'ViewAll'"
                v-gtm:@click
                v-on:click="navigateToMatches"
            >
                <template #content-left>
                    {{ i18n.t('fantasy_selection_view_all') }}
                </template>
                <template #icon>
                    <SboIcon name="system:arrowRight" right />
                </template>
            </VButton>
        </div>
        <div class="matchCardList">
            <UpcomingMatch
                v-for="event in events"
                v-bind:key="event.id"
                v-gtm:type="'Upcoming'"
                v-bind:event="event"
                class="upcomingMatchCard"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { useRouter } from 'vue-router';
    import SboIcon from '@/components/common/SboIcon.vue';
    import StaticSpinner from '@/components/common/StaticSpinner.vue';
    import VButton from '@/components/common/button/VButton.vue';
    import Heading from '@/components/tournamentCenter/Heading.vue';
    import UpcomingMatch from '@/components/tournamentCenter/UpcomingMatch.vue';
    import { i18n } from '@/core/lib/i18n';
    import type { ITournamentEvent } from '@/interface/tournamentCenter';

    defineProps<{
        events: ITournamentEvent[];
        isEventsLoaded: boolean;
    }>();

    const router = useRouter();
    const navigateToMatches = () => {
        router.push({ name: 'TournamentMatches' });
    };

</script>

<style lang="scss" scoped>
    @import "@/components/tournamentCenter/UpcomingMatch";
</style>
